var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack239({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.57,10.38h-.8V9.09H5.82l.35-1.72H4.77V6.07H6.44L6.9,3.79H8.21L7.75,6.07h1.3L9.5,3.79h1.36l-.47,2.28h.81v1.3H10.12L9.77,9.09H11.2v1.29H9.51l-.46,2.29H7.74l.45-2.29H6.89l-.46,2.29H5.1Zm1.92-3L7.15,9.09h1.3l.34-1.72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack239);
export default __webpack_public_path__ + "static/media/Symbolpack_2_39.004cd49256fc4fb82a01106156ee299d.svg";
export { ForwardRef as ReactComponent };